import { useEffect, useState, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import './index.scss'

function DisplayText(props) {
  const { fullText, desktopFontSize=56 } = props;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [displayText, setDisplayText] = useState('');
  const [hasStarted, setHasStarted] = useState(false);
  const containerRef = useRef(null);

  // 监听组件是否进入视口
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [hasStarted]);

  // 进入视口后才开始文字动画
  useEffect(() => {
    if (!hasStarted) return;

    let i = 0;
    const timer = setInterval(() => {
      if (i <= fullText.length) {
        setDisplayText(fullText.slice(0, i));
        i++;
      } else {
        clearInterval(timer);
      }
    }, 100);

    return () => clearInterval(timer);
  }, [fullText, hasStarted]);

  return (
    <div ref={containerRef} className={`display-text-wrap relative`}>
      {
        isMobile?(
          <span className={`display-text font-medium text-[24px]`}>{fullText}</span>
        ):(
          <>
            <span
              className={`display-text text-[56px] font-medium`} style={{ fontSize: desktopFontSize ? `${desktopFontSize}px` : undefined }}>{displayText}</span>
            <span className={`display-cursor ${isMobile ? `w-[8px] h-[8px]` : `w-[16px] h-[16px]`} `} />
          </>
        )
      }

    </div>
  );
}

export default DisplayText